export const GET_DAILY_DIARY_ACTIVITIES = 'GET_DAILY_DIARY_ACTIVITIES'
export const GET_DAILY_DIARY_ACTIVITIES_SUCCESS = 'GET_DAILY_DIARY_ACTIVITIES_SUCCESS'
export const GET_DAILY_DIARY_ACTIVITIES_FAILED = 'GET_DAILY_DIARY_ACTIVITIES_FAILED'

export const CLEAR_DAILY_DIARY_ACTIVITIES = 'CLEAR_DAILY_DIARY_ACTIVITIES'

export const UPDATE_ACTIVITY_MEDIA = 'UPDATE_ACTIVITY_MEDIA'
